<template>
  <div class="container-fluid p-0 justify-content-center position-relative playlist-container">
    <!-- <div class="position-absolute w-100 h-100" style="background-image: url('${import.meta.env.VITE_NGINX_URL}/23299312_m3.jpg'); background-size: cover; background-position: center;"></div> -->
    <div class="text-white w-100 position-relative" style="background-color: rgba(0, 0, 0, 0,0.1);">
      <h4 class="text-center">待播歌曲</h4>
      <ul class="song-list" v-if="playlist.length > 0">
        <li v-for="(song, index) in playlist" :key="song.id" class="d-flex align-items-center">
          <span>
            <h6 class="mb-0 text-dark">{{ index + 1 }}.  {{ song.songname }}</h6>
          </span>
          <button @click="showDeleteConfirm(index, song)" class="btn btn-icon" title="取消">
            <i class="fas fa-trash-alt"></i>
          </button>
          <button @click="moveSongUp(index)" class="btn btn-icon" title="插播">
            <i class="fas fa-cut"></i>
          </button>
        </li>
      </ul>
      <div v-if="playlist.length === 0" class="empty-playlist-message">
        <p>目前沒有待播歌曲</p>
      </div>
    </div>

    <!-- 刪除確認對話框 -->
    <div v-if="showDeleteModal" class="modal-overlay">
      <div class="modal-content">
        <h5>確認取消</h5>
        <p>確定要取消歌曲 "{{ songToDelete?.songname }}" 嗎？</p>
        <div class="modal-buttons">
          <button @click="confirmDelete" class="btn-confirm">確定</button>
          <button @click="cancelDelete" class="btn-cancel">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { usePlaylistStore } from '../store/usePlaylistStore';
import { nextTick, ref } from 'vue';
import TestPinia from './testpinia.vue';
import Playerhc from './Playerhc.vue';

const { playlist, addSong, removeSong, moveSongUp } = usePlaylistStore();

// 刪除相關的響應式變量
const showDeleteModal = ref(false);
const songToDelete = ref(null);
const indexToDelete = ref(null);

// 顯示刪除確認對話框
const showDeleteConfirm = (index, song) => {
  songToDelete.value = song;
  indexToDelete.value = index;
  showDeleteModal.value = true;
};

// 確認刪除
const confirmDelete = () => {
  if (songToDelete.value && songToDelete.value.id) {
    removeSong(songToDelete.value.id);  // 使用歌曲ID而不是索引
    showDeleteModal.value = false;
    songToDelete.value = null;
    indexToDelete.value = null;
  }
};

// 取消刪除
const cancelDelete = () => {
  showDeleteModal.value = false;
  songToDelete.value = null;
  indexToDelete.value = null;
};

const addTestSong = () => {
  addSong({
    id: 1,
    songname: '111',
    filename: '年轻人就该出去溜达溜达 - 李二萌_prob5.mkv',
    stateA: false,
    stateB: false,
  });
};
</script>

<style scoped>
.btn-icon {
  background: none;
  border: none;
  padding: 5px;
  margin-left: 8px;
  cursor: pointer;
  transition: transform 0.2s;
  color: white;
}

.btn-icon:hover {
  transform: scale(1.1);
}

.btn-icon i {
  font-size: 16px;
  opacity: 0.8;
}

.btn-icon:hover i {
  opacity: 1;
}

/* 為不同按鈕設置不同的懸停顏色 */
.btn-icon:hover .fa-trash-alt {
  color: #dc3545;
}

.btn-icon:hover .fa-cut {
  color: #007bff;
}

/* 模態框樣式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000; /* 降低 z-index，避免覆蓋其他 modal */
}

.modal-content {
  background-color: #6488b0;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  position: relative;
  z-index: 5001;  /* 比 modal-overlay 更高 */
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.btn-confirm, .btn-cancel {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-confirm {
  background-color: #dc3545;
  color: white;
}

.btn-confirm:hover {
  background-color: #c82333;
}

.btn-cancel {
  background-color: #6c757d;
  color: white;
}

.btn-cancel:hover {
  background-color: #5a6268;
}

.playlist-container {
  margin-bottom: 40px !important;
  margin-top: 5px !important;
  z-index: 1000 !important; /* 降低 z-index，避免覆蓋 modal */
  position: relative !important;
  min-height: 10rem;
  max-height: 40rem;
  height: auto;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
}

.song-list {
  padding-left: 0.5rem;
  margin-bottom: 0;
  list-style-type: none;
  overflow-y: visible !important;
}

.song-list li {
  margin-bottom: 0.1rem;
  padding: 0.2rem;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color 0.2s;
}

.song-list li:hover {
  background-color: rgba(0, 0, 0, 0);
}

.empty-playlist-message {
  text-align: center;
  padding: 2rem;
  color: rgba(255, 255, 255, 0.7);
  font-style: italic;
}

/* 響應式調整 */
@media (max-width: 768px) {
  .playlist-container {
    min-height: 5rem;
    max-height: 20rem;
    margin-bottom: 15px !important;
    margin-top: 8px !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }
  
  /* 調整標題大小和間距 */
  h4 {
    font-size: 1.1rem !important;
    margin-bottom: 0.5rem !important;
    margin-top: 0 !important;
  }
  
  /* 調整歌曲列表項的間距 */
  .song-list {
    padding-left: 0.25rem !important;
  }
  
  .song-list li {
    margin-bottom: 0 !important;
    padding: 0.1rem !important;
  }
  
  /* 調整歌曲名稱的字體大小 */
  .song-list h6 {
    font-size: 0.9rem !important;
  }
  
  /* 調整按鈕大小 */
  .btn-icon {
    padding: 3px !important;
    margin-left: 5px !important;
  }
  
  .btn-icon i {
    font-size: 14px !important;
  }
}

/* 超小屏幕設備進一步優化 */
@media (max-width: 480px) {
  .playlist-container {
    min-height: 3rem !important;
    margin-bottom: 8px !important;
    margin-top: 10px !important;
  }
  
  h4 {
    font-size: 1rem !important;
    margin-bottom: 0.25rem !important;
  }
  
  .song-list h6 {
    font-size: 0.85rem !important;
  }
  
  .empty-playlist-message {
    padding: 0.5rem !important;
  }
  
  .empty-playlist-message p {
    margin: 0 !important;
    font-size: 0.85rem !important;
  }
}
</style>

